import { inject, Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { map, take, Observable } from 'rxjs';


import { UserAuthenticationService } from '../google/user-authentication.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  private router = inject(Router);

  // Depends of user authentication service
  private userAuthentication = inject(UserAuthenticationService)
  canActivate(): Observable<boolean> {
    return this.userAuthentication.getUserIsLoggedValue().pipe(
      take(1), // Take current value and complete
      map(isAuthenticated => {
        if (isAuthenticated) {
          return true;
        } else {
          this.router.navigate(['/login']);
          return false;
        }
      })
    );
  }


}
